import {
  CardPaper,
  CardStack,
  ImageContainer,
  CardImage,
  ContentBox,
  CardTitle,
  CardSubTitle,
  CardDescription,
} from './styles';

const DashboardCard = ({ title, description, reverse = false, subTitle, image }) => {
  return (
    <CardPaper elevation={0}>
      <CardStack direction={{ xs: 'column', md: reverse ? 'row-reverse' : 'row' }}>
        <ImageContainer>
          <CardImage component="img" src={image} />
        </ImageContainer>

        <ContentBox>
          <CardTitle reverse={reverse}>{title}</CardTitle>
          {subTitle && <CardSubTitle reverse={reverse}>{subTitle}</CardSubTitle>}
          <CardDescription reverse={reverse}>{description}</CardDescription>
        </ContentBox>
      </CardStack>
    </CardPaper>
  );
};

export default DashboardCard;
